import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetDefinitionAudioV2Response } from './get-definition-audio-v2-response';
import { getDefinitionAudioV2ResponseSchema } from './get-definition-audio-v2-response';

export async function getDefinitionAudioV2Api(
  slug: string,
): Promise<IValidatedResponse<IGetDefinitionAudioV2Response>> {
  return getRequest<IGetDefinitionAudioV2Response>({
    path: `/challenges/${slug}/audio/v2/definition`,
    schema: getDefinitionAudioV2ResponseSchema,
  });
}
